import { render, staticRenderFns } from "./tableBalance.vue?vue&type=template&id=7410a824"
import script from "./tableBalance.vue?vue&type=script&lang=js"
export * from "./tableBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports